import {EnvironmentMap, RoutesMap, TaskPhaseStatusColors} from "../interfaces/common";

export const MOBILE_WIDTH = 768;
export const CLICK_EVENT: string = "click";
export const ENTER_KEY: string = "Enter";

export const Routes: RoutesMap = {
    JOBS: "jobs",
    FAQ: "faq",
    SUPPORT: "support",
    UNAUTHORIZED: "unauthorized",
    PAGE_NOT_FOUND: "pageNotFound",
};

export const TaskStatusMap: TaskPhaseStatusColors = {
    COMPLETED: "#1C8843FF",
    NEW: "#803F97FF",
    FAILED: "#D62027FF",
    IN_PROGRESS: "#2375BDFF",
    NOT_STARTED: "#5F5F5FFF",
    READY: "#803F97FF",
    REJECTED: "#D62027FF",
    REOPENED: "#BF4D00FF",
    SKIPPED: "#5F5F5FFF",
};

export const EnvMap: EnvironmentMap = {
    PROD: "prod",
    DEV: "dev",
    STG: "stg",
    STG1: "stg1",
    STG2: "stg2",
};

export const DrawerTabs = {
    STATS: "task-stats",
    DETAILS: "task-details",
};

export const ViewRoutes: string[] = ["jobs", "faq"];

export const FaqTypeAll: string = "All";

export const MAIL_LINK = "contact@tpdataforce.com";
